import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Label from '../Label/Label.jsx';
import FlexContainer from '../FlexContainer/FlexContainer.jsx';
import Modal from '../Modal/Modal.jsx';
import CardTitle from '../Headings/CardTitle/CardTitle.jsx';
import InformationCircleContained from '../Icons/InformationCircleContained.jsx';
import {colors} from '../../utils/colors.js';
import {formatCurrency} from '../../utils/formatCurrency.js';
import {useCurrentHotel} from '../../providers/CurrentHotelProvider.jsx';

const INTERACTION_LABELS = {
  EMAIL_SENT: {text: 'Email Sent', backgroundColor: colors.tips20, color: colors.tips},
  EMAIL_OPENED: {text: 'Email Open', backgroundColor: colors.tips20, color: colors.tips},
  EMAIL_CLICKED: {text: 'Email Clicked', variant: 'warning'},
  ROOM_UPGRADE_PENDING: {text: 'Pending Room', variant: 'warning'},
  EXTRA_SERVICES_PENDING: {text: 'Pending Extra', variant: 'warning'},
  UPGRADE_CONFIRMED: {text: 'Confirmed Room', variant: 'success'},
  UPGRADE_DENIED: {text: 'Denied Room', variant: 'danger'},
  TRANSACTION: {text: 'Transaction', variant: 'success'},
};

const PreArrivalInteractionLabel = ({
  preArrivalInteraction,
  abandonedCart,
  reservation,
}) => {
  if (!preArrivalInteraction) {
    return null;
  }

  if (preArrivalInteraction === 'ABANDONED_CART' && abandonedCart) {
    return (
      <AbandonedCartInteraction
        abandonedCart={abandonedCart}
        reservation={reservation}
      />
    );
  }

  const config = INTERACTION_LABELS[preArrivalInteraction];

  if (!config) {
    return null;
  }

  if (config.variant) {
    return <Label variant={config.variant}>{config.text}</Label>;
  }

  return (
    <Label backgroundColor={config.backgroundColor} color={config.color}>
      {config.text}
    </Label>
  );
};

const AbandonedCartInteraction = ({abandonedCart, reservation}) => {
  const {currentHotel} = useCurrentHotel();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <span style={{cursor: 'pointer'}} onClick={handleOpenModal}>
        <FlexContainer alignItems="center">
          <Label variant="danger">Abandoned Cart</Label>
          <InformationCircleContained color={colors.grey64} />
        </FlexContainer>
      </span>
      {isModalOpen &&
        <Modal
          title="Abandoned Cart Items"
          onClose={handleCloseModal}
          isOpen={true}
        >
          {abandonedCart.upgrades && abandonedCart.upgrades.length > 0 &&
            <div>
              <CardTitle>Room Upgrades</CardTitle>
              {abandonedCart.upgrades.map((item, index) => (
                <p key={index} style={{marginBottom: '10px'}}>
                  - {item.name} - <b>{formatCurrency(item.amount, currentHotel?.currency)}</b>
                  &nbsp;({formatCurrency(item.amount / (reservation?.nights || 1), currentHotel?.currency)} /per night)
                </p>
              ))}
            </div>
          }
          {abandonedCart.extras && abandonedCart.extras.length > 0 &&
            <div>
              <CardTitle>Extra Services</CardTitle>
              {abandonedCart.extras.map((item, index) => (
                <p key={index} style={{marginBottom: '10px'}}>
                  <b>{item.quantity}x</b> {item.name}
                  {item.variation &&
                    <Label backgroundColor={colors.primary20} color={colors.primaryColor}>
                      {item.variation.name}
                    </Label>
                  }
                  {' '}- <b>{formatCurrency(item.price, currentHotel?.currency)}</b>
                </p>
              ))}
            </div>
          }
        </Modal>
      }
    </>
  );
};

PreArrivalInteractionLabel.propTypes = {
  preArrivalInteraction: PropTypes.string,
  abandonedCart: PropTypes.object,
  reservation: PropTypes.object,
};

export default PreArrivalInteractionLabel;
